import { cartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.header = {
    condensedViewCheckboxGroup: {
        css: css`
            margin-left: auto;
            display: none;
        `,
    },
};
cartLinesStyles.headerWrapper = {
    css: css`
        background: ${getColor("common.accent")};
        padding: 10px 20px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        margin-top: 10px;
                        margin-bottom: 13px;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
        section {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    `,
};
